import {Component} from '@angular/core';

@Component({
  selector: 'app-logos-with-link',
  templateUrl: './logos-with-link.component.html',
  styleUrls: ['./logos-with-link.component.css']
})
export class LogosWithLinkComponent {
  constructor() { }
}
